import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import {
  withStyles,
  Tabs,
  Fade,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core'
import useShopStyles from '../../components/Shop/Shop.style'
import { connect } from 'react-redux'
import OutfitTab from '../Shop/OutfitTab'
import PacksTab from './PacksTab'
import Link from '../Link/Link'
import Button from '../Button/Button'
import { getPacksByPackTaxonId } from '../../redux/actions/packs'
import { KeyboardArrowRight } from '@material-ui/icons'
import { getLatestProducts } from '../../redux/actions/products'
import { useRouter } from 'next/router'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { useScrollState } from '../../utils/scrollState'
import { useSticky } from '../../utils/useSticky'
import CMSText, { isPrismicText } from '../Global/CMSText'

type Tprops = {
  theme?: any
  shopText: any
  taxonsPacks?: any
  packs?: any
  text: any
  settings: any
  t?: any
  latestProducts: any
  currentShopPage: number
  getPacksByPackTaxonId?: (id: number | boolean) => void
  getLatestProducts?: () => void
  productTaxons: any
  takeback: any
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {},
  })
)

const OutfitTabs = withStyles((theme: Theme) => ({
  root: {
    borderBottom: 0,
    minHeight: 32,
    [theme.breakpoints.down('md')]: {
      minWidth: '100%',
    },
    '& .MuiTabScrollButton-root': {
      width: 32,
      '&.Mui-disabled': {
        opacity: 0.3,
      },
    },
  },
  indicator: {
    backgroundColor: 'transparent',
  },
}))(Tabs)

function a11yProps(index: any) {
  return {
    id: `outfit-tab-${index}`,
    'aria-controls': `outfit-tabpanel-${index}`,
  }
}

const mapStateToProps = (state) => ({
  packs: state.packs,
  latestProducts: state.products.latestProducts,
  currentShopPage: state.products.items.page,
  productTaxons: state.taxons,
})

const mapDispatchToProps = {
  getPacksByPackTaxonId: getPacksByPackTaxonId,
  getLatestProducts: getLatestProducts,
}

const PacksCatalog = ({
  taxonsPacks,
  packs,
  getPacksByPackTaxonId,
  t,
  shopText,
  latestProducts,
  currentShopPage,
  text,
  settings,
  productTaxons,
  getLatestProducts,
  takeback,
}: Tprops) => {
  const classes = useStyles()
  const LayoutStyle = {}
  const shopClasses = useShopStyles(LayoutStyle)
  const router = useRouter()
  const cat = router?.query?.cat
  const [selectedCategory, setSelectedCategories] = useState(
    typeof cat !== 'undefined' && typeof taxonsPacks !== 'undefined'
      ? taxonsPacks?.findIndex((taxon) => taxon.code === cat)
      : 0
  )
  const packPushs = text?.pushs
  const [packPush, setPackPush] = useState()
  const { trackEvent, pushInstruction } = useMatomo()
  const scrollState = useScrollState()

  const isSticky = useSticky(false)

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    const taxonCode = taxonsPacks[newValue].code
    const taxonId = taxonsPacks[newValue].id
    // Update query url to keep tracking history
    window.history.replaceState(
      {
        ...window.history.state,
        as: `/packs?cat=${taxonCode}`,
        url: `/packs?cat=${taxonCode}`,
      },
      '',
      `?cat=${taxonCode}`
    )
    router.push(`?cat=${taxonCode}`, undefined, {
      shallow: true,
    })
    setSelectedCategories(newValue)
    trackEvent({
      category: 'Packs',
      action: `Change category`,
      name: `${taxonId}`,
    })
    pushInstruction('setEcommerceView', false, false, taxonId)
    pushInstruction('trackPageView', taxonId)
    // get Pack by taxon Id
    getPacksByPackTaxonId(taxonId)
  }

  useEffect(() => {
    if (
      typeof taxonsPacks !== 'undefined' &&
      taxonsPacks.length > 0 &&
      typeof cat === 'undefined'
    ) {
      // get default packs with first taxon id
      const taxonId = taxonsPacks[0].id
      getPacksByPackTaxonId(taxonsPacks[0].id)
      pushInstruction('setEcommerceView', false, false, taxonId)
      pushInstruction('trackPageView', taxonId)

      // Look in Prismic Pack Push related category and set it
      const taxonCode = taxonsPacks[0].code
      const taxonPush = packPushs?.filter(
        (el) => el.taxon_pack_code[0]?.text === taxonCode
      )
      setPackPush(taxonPush)
    } else if (typeof taxonsPacks !== 'undefined') {
      const idCat =
        typeof cat !== 'undefined'
          ? taxonsPacks?.find((taxon) => taxon.code === cat)?.id
          : taxonsPacks[0]?.id
      getPacksByPackTaxonId(idCat)
      setSelectedCategories(
        taxonsPacks?.findIndex((taxon) => taxon.code === cat)
      )
      pushInstruction('setEcommerceView', false, false, idCat)
      pushInstruction('trackPageView', idCat)

      // Look in Prismic Pack Push related category and set it
      const taxonCode = taxonsPacks?.find((taxon) => taxon.code === cat)?.code
      const taxonPush = packPushs?.filter(
        (el) => el.taxon_pack_code[0]?.text === taxonCode
      )
      setPackPush(taxonPush)
    }
  }, [taxonsPacks])

  useEffect(() => {
    getLatestProducts()
  }, [])

  return (
    <div className={`catalog ${classes.root}`} id={'catalog'}>
      <div className={'spy'} />
      {typeof taxonsPacks !== 'undefined' && taxonsPacks.length > 0 && (
        <div
          className={clsx(
            'sticky-bar',
            'sticky-bar--pack',
            shopClasses.stickyBar,
            isSticky && [shopClasses.stickyBarSticked, 'sticky-bar--sticked'],
            scrollState.showOnTop && [
              shopClasses.stickyBarTop,
              'sticky-bar--top',
            ],
            scrollState.showOnScrollUp && [
              shopClasses.stickyBarScrollUp,
              'sticky-bar--scrollup',
            ]
          )}
        >
          <div className={`shop-menu shop-menu--pack ${shopClasses.shopMenu}`}>
            <div className={`shop-menu__list ${shopClasses.shopMenuList}`}>
              <OutfitTabs
                variant="scrollable"
                scrollButtons="auto"
                value={selectedCategory}
                onChange={handleChange}
                aria-label="Outfits"
              >
                {taxonsPacks.map(({ name }, index) => {
                  return (
                    <OutfitTab
                      key={`tabpanel-${index}`}
                      label={name}
                      {...a11yProps(index)}
                    />
                  )
                })}
              </OutfitTabs>
            </div>
            {isPrismicText(text?.pack_to_shop_button) && (
              <div className={`shop-menu__cta ${shopClasses.shopMenuCta}`}>
                <Link
                  href={
                    currentShopPage !== 1 &&
                    productTaxons?.items?.length > 0 &&
                    localStorage.getItem('selectedCategory') !== null
                      ? `/${
                          productTaxons?.items[0]?.children[
                            localStorage.getItem('selectedCategory')
                          ]?.slug
                        }?currentPage=${currentShopPage}`
                      : '/shop'
                  }
                >
                  <a>
                    <Button
                      variant="outlined"
                      size="small"
                      component="span"
                      className="shop-menu__cta-link"
                      onClick={() =>
                        trackEvent({
                          category: 'Packs',
                          href: '/shop',
                          action: `Pack to Shop`,
                        })
                      }
                      color="primary"
                      endIcon={<KeyboardArrowRight />}
                    >
                      <CMSText
                        asText
                        data={text?.pack_to_shop_button}
                        defaultText={t('texts:packs:pack_to_shop_button')}
                      />
                    </Button>
                  </a>
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
      <Fade in={packs.loading === false}>
        <div data-packs={packs.loading === false ? 'loaded' : 'loading'}>
          {packs && (
            <PacksTab
              latestProducts={latestProducts}
              packs={packs}
              t={t}
              shopText={shopText}
              text={text}
              settings={settings}
              packPush={packPush}
              takeback={takeback}
            />
          )}
        </div>
      </Fade>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PacksCatalog)
